import type { ShareAction } from "#common/types/vault";

/** Attribute conditions offered when building a live rule (client is fixed by the workspace). */
export const COND_ATTRS: { key: string; label: string }[] = [
  { key: "entity", label: "Entity" },
  { key: "period", label: "Reporting Period" },
  { key: "investor", label: "LP / Investor" },
  { key: "status", label: "Document Status" },
];

export const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export type ShareTone = "live" | "frozen";
export const ACTION_META: Record<
  ShareAction,
  { verb: string; tone: ShareTone; group: string }
> = {
  rule_created: { verb: "Created live rule", tone: "live", group: "rules" },
  collection_shared: { verb: "Shared collection", tone: "frozen", group: "collections" },
  docs_added_rule: { verb: "Document entered live rule", tone: "live", group: "additions" },
  docs_added_collection: {
    verb: "Documents added to collection",
    tone: "frozen",
    group: "additions",
  },
};
